import React from "react";
import { useHeaderState } from "components";
import "./Hamburger.scss";

/**
 * Component for the mobile hamburger menu
 *
 * @returns The hamburger component for browsers smaller than mobile
 *
 */
export const Hamburger = (): JSX.Element => {
  // get the state of the menu whether it is open or closed
  const {
    dispatch,
    state: { menuOpen },
  } = useHeaderState();

  const onClick = () => {
    document.body.classList.toggle("hamburger-open");
    dispatch({ type: "setMenuOpen", data: !menuOpen });
  };

  return (
    <button
      onClick={() => onClick()}
      type="button"
      className={`hamburger ${menuOpen ? "hamburger--open" : ""}`}
      aria-expanded={menuOpen}
      aria-label={menuOpen ? "Close navigation" : "Open navigation"}
    >
      <div className="hamburger__icon">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </button>
  );
};
